export const LOCALS = {
    CS: "cs",
    UK: "uk",
    RU: "ru",
};

export const IMAGESWORKS = [
    require("../../assets/photos/01.jpg"),
    require("../../assets/photos/02.jpg"),
    require("../../assets/photos/03.jpg"),
    require("../../assets/photos/04.jpg"),
    require("../../assets/photos/05.jpg"),
    require("../../assets/photos/06.jpg"),
    require("../../assets/photos/07.jpg"),
    require("../../assets/photos/08.jpg"),
    require("../../assets/photos/09.jpg"),
    require("../../assets/photos/10.jpg"),
    require("../../assets/photos/11.jpg"),
];
